const en = {
    translation: {
        core: {
            cardDetails: {
                accountEnding: 'Account ending in {{accountLast4}}'
            },
            errorMessages: {
                havingTrouble: 'We’re having trouble retrieving your information',
                tryAgainLater: 'Please try again later.'
            }
        }
    }
};
export default en;
